import moment from 'moment';
import { InferType, object, string, number, boolean, mixed } from 'yup';

import i18n from '@components/i18n';
import { yupMultipleFiles, yupMobileNumber } from '@utils/yup';
import { HealthClaimTypes } from '@models/HealthClaim';
import { PaymentMethods } from '@models/PaymentInfo';

export const formValuesSchema = object().shape({
  policyHolder: string().default('').required(i18n.t('validation:required')),
  policyNumber: string().default('').required(i18n.t('validation:required')),
  policyOrderNumber: string().default('').required(i18n.t('validation:required')),
  policyExpiryDate: string()
    .default(() => moment(new Date()).format('YYYY-MM-DDTHH:mm'))
    .required(i18n.t('validation:required')),

  useMainContact: boolean().default(true),
  mobileNumber: yupMobileNumber().default(''),
  email: string().email(i18n.t('validation:email')).optional(),

  paymentInfo: object({
    paymentMethod: string().default('').required(i18n.t('validation:required')),
    beneficiaryName: string().default('').required(i18n.t('validation:required')),
    bankName: string()
      .default('')
      .when('paymentMethod', {
        is: (paymentMethod: string) => paymentMethod === PaymentMethods.BankTransfer,
        then: (schema) => schema.required(i18n.t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
    bankAccount: string()
      .default('')
      .when('paymentMethod', {
        is: (paymentMethod: string) => paymentMethod === PaymentMethods.BankTransfer,
        then: (schema) => schema.required(i18n.t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
  }),

  accidentHappenedAt: string().default('').required(i18n.t('validation:required')),
  claimType: mixed<HealthClaimTypes>().oneOf(Object.values(HealthClaimTypes)).required(i18n.t('validation:required')),
  supportingDocuments: yupMultipleFiles({ required: true }),
  totalClaimedAmount: number()
    .default(0)
    .required(i18n.t('validation:required'))
    .positive(i18n.t('validation:positive')),

  acceptTermsAndConditions: boolean()
    .default(false)
    .test('required', i18n.t('validation:required'), (checked) => checked === true),
});

export type FormValues = InferType<typeof formValuesSchema>;
